import type { ArticleData } from '@/mocks/articles';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuy.beer';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg';

interface ArticleSchemaProps {
  article: ArticleData;
}

export default function ArticleSchema({ article }: ArticleSchemaProps) {
  const pageUrl = `${siteUrl}/${article.slug}/`;

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    image: article.imageUrl,
    datePublished: '2026-06-01',
    dateModified: '2026-06-28',
    author: {
      '@type': 'Organization',
      name: 'VigorBuy Spreadsheet',
    },
    publisher: {
      '@type': 'Organization',
      name: 'VigorBuy Spreadsheet',
      logo: {
        '@type': 'ImageObject',
        url: logoUrl,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageUrl,
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: article.title,
        item: pageUrl,
      },
    ],
  };

  let faqPageSchema: Record<string, unknown> | null = null;
  if (article.tag === 'FAQ') {
    faqPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: article.sections
        .filter((s) => s.headingLevel === 'h3')
        .map((s) => ({
          '@type': 'Question' as const,
          name: s.heading,
          acceptedAnswer: {
            '@type': 'Answer' as const,
            text: s.paragraphs.join(' '),
          },
        })),
    };
  }

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      {faqPageSchema && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }} />
      )}
    </>
  );
}